import { env } from './env';

const BASE = env?.VITE_SUPABASE_URL ?? '';

/**
 * Public URL for an object in the `shop` bucket. Thumbnails are generated at
 * upload time (see `compress.ts`) rather than with Supabase image
 * transformations, which require a paid plan.
 */
export function imageUrl(path: string) {
  if (!BASE || !path) return '';
  const encoded = path
    .split('/')
    .map((segment) => encodeURIComponent(segment))
    .join('/');
  return `${BASE}/storage/v1/object/public/shop/${encoded}`;
}

/** Prefer the thumbnail; fall back to the full image for legacy rows. */
export function imageSrc(image: { path: string; thumbPath?: string | null }) {
  return imageUrl(image.thumbPath || image.path);
}
